"use strict";

var _toConsumableArray = require("/codebuild/output/src2730718938/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/codebuild/output/src2730718938/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Zoom = _interopRequireDefault(require("@material-ui/core/Zoom"));
var _colors = require("../config/colors.config");
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    /* override default 'fieldset' style */
    fieldset: {
      border: 0,
      margin: 0,
      padding: 0
    },
    /* styles that reflect the selected/unselected state */
    root: {
      '& .MuiChip-clickable:hover .MuiChip-label': {
        color: theme.palette.primary.mainLight
      },
      '& .MuiFab-label > span': {
        top: 80
      },
      '& > *': {
        '& .MuiChip-avatar': {
          height: 58,
          width: 58
        },
        height: 72,
        margin: '6px 6px 30px',
        width: 72
      },
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      margin: 2
    },
    selectedChip: {
      '& .MuiChip-label': {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        letterSpacing: -0.2
      },
      boxShadow: "0 0 0 4px white, 0 0 0 8px ".concat(theme.palette.primary.main)
    },
    unselectedChip: {
      opacity: theme.palette.type === 'dark' ? 1 : 0.7
    }
  };
});
var ChipsSelect = function ChipsSelect(props) {
  var children = props.children,
    name = props.name,
    items = props.items,
    onSelect = props.onSelect,
    parentValue = props.parentValue,
    _props$isMulti = props.isMulti,
    isMulti = _props$isMulti === void 0 ? false : _props$isMulti;
  var classes = useStyles();
  var initSelectedChip = isMulti ? [] : '';
  var _react$default$useSta = _react.default.useState(initSelectedChip),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    selectedChip = _react$default$useSta2[0],
    setSelectedChip = _react$default$useSta2[1];
  var chipsData = items;
  var handleClick = function handleClick(chip) {
    var newValue;
    if (isMulti) {
      newValue = _toConsumableArray(selectedChip);
      var itemIndex = selectedChip.indexOf(chip);
      if (itemIndex === -1) {
        newValue.push(chip);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = chip;
    }
    setSelectedChip(newValue);
    if (onSelect) {
      onSelect(newValue);
    }
  };
  var isChipSelected = function isChipSelected(chip) {
    if (isMulti) {
      return selectedChip.includes(chip);
    }
    return selectedChip === chip;
  };
  var isChipUnselected = function isChipUnselected(chip) {
    if (isMulti) {
      return Boolean(selectedChip) && selectedChip.length > 0 && selectedChip.includes(chip);
    }
    return selectedChip !== '' && selectedChip !== chip;
  };
  var LightTooltip = (0, _styles.withStyles)(function () {
    return {
      tooltip: {
        '&:before': {
          borderBottomColor: 'transparent',
          borderColor: 'transparent',
          borderWidth: 0
        },
        backgroundColor: 'transparent',
        border: '0px',
        borderRadius: 0,
        boxShadow: 'none',
        color: _colors.Red[500],
        fontSize: 11,
        fontWeight: 'bold',
        marginTop: -110
      }
    };
  })(_Tooltip.default);
  _react.default.useEffect(function () {
    if (parentValue === undefined) {
      // do nothing
    } else if (parentValue) {
      setSelectedChip(parentValue);
    } else if (isMulti) {
      setSelectedChip([]);
    } else {
      setSelectedChip('');
    }
  }, [parentValue, isMulti]);
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: classes.fieldset,
    "aria-labelledby": name ? "".concat(name, "-label") : undefined
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: isMulti ? 'group' : 'radiogroup',
    className: classes.root
  }, chipsData.map(function (data, index) {
    return /*#__PURE__*/_react.default.createElement(_Zoom.default, {
      in: true,
      key: index,
      style: {
        transitionDelay: "".concat(index * 60, "ms")
      }
    }, data.disabled ? /*#__PURE__*/_react.default.createElement(LightTooltip, {
      title: /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, data.disabledTooltip, /*#__PURE__*/_react.default.createElement("br", null), data.disabledTooltip_line_2)
    }, /*#__PURE__*/_react.default.createElement(_Chip.default, {
      role: isMulti ? 'checkbox' : 'radio',
      key: index,
      "data-test-id": data.value,
      label: data.label,
      avatar: /*#__PURE__*/_react.default.createElement(_Avatar.default, {
        alt: '',
        src: data.imgSrc,
        "aria-hidden": "true"
      }),
      style: isMulti ? {
        margin: '6px 15px 50px'
      } : undefined
      /* eslint-disable-next-line no-nested-ternary */,
      className:
      // eslint-disable-next-line no-nested-ternary
      isChipSelected(data.value) ? classes.selectedChip : isChipUnselected(data.value) ? classes.unselectedChip : '',
      "aria-checked": isChipSelected(data.value)
    })) : /*#__PURE__*/_react.default.createElement(_Chip.default, {
      role: isMulti ? 'checkbox' : 'radio',
      key: index,
      "data-test-id": data.value,
      label: data.label,
      onClick: function onClick() {
        return handleClick(data.value);
      },
      avatar: /*#__PURE__*/_react.default.createElement(_Avatar.default, {
        alt: '',
        src: data.imgSrc,
        "aria-hidden": "true"
      }),
      style: isMulti ? {
        margin: '6px 15px 50px'
      } : undefined
      /* eslint-disable-next-line no-nested-ternary */,
      className:
      // eslint-disable-next-line no-nested-ternary
      isChipSelected(data.value) ? classes.selectedChip : isChipUnselected(data.value) ? classes.unselectedChip : '',
      "aria-checked": isChipSelected(data.value)
    }));
  }), /* allows to add more 'chips' to the items, like an 'addButton' etc. */
  children ? /*#__PURE__*/_react.default.createElement(_Zoom.default, {
    in: true,
    key: 'btn',
    style: {
      transitionDelay: "".concat(chipsData.length * 60, "ms")
    }
  }, children) : false));
};
ChipsSelect.propTypes = {
  children: _propTypes.default.any,
  isMulti: _propTypes.default.bool,
  items: _propTypes.default.array,
  name: _propTypes.default.string,
  // enable selecting/unselecting multiple chips
  onSelect: _propTypes.default.func,
  // enable adding more special chips, like buttons etc.
  parentValue: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.number])
};
var _default = exports.default = ChipsSelect;